export const ordersTabs = [
  { label: "Details", value: "details" },
  { label: "Product", value: "product" },
  { label: "Transaction", value: "transaction" },
  { label: "Documents", value: "documents" },
];
